import React from 'react';
import styled from "styled-components"

const Container = styled.div`
    background-color: ${({ theme }) => theme.color.secondaryBg};
    border-radius: 19px;
    min-width: 258px;
    // height: 144px;
    padding: 24px 10px 20px;
    margin-right: 100%;
`

const Body = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
`
const Flag = styled.img`
object-fit:cover;
    width: 33px;
    height: 49px;
    margin-bottom: 8px;
    border-radius: 4px;
`
const Text = styled.p`
    max-width: 57px;
    font-family: 'Poppins Bold';
    font-size: 12px;
    text-align: center;
    color: ${({ theme }) => theme.color.primary};
`

const ScoreText = styled(Text)`
    font-size: 16px;
`

// const Title = styled(Text)`
//     // width: 100%;
//     margin:auto;
//     font-size: 16px;
//     text-align: center;
// `
const Team = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
`
const Score = styled.div.attrs({
    min: "0"
})`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    align-items: center;
    `

const Numbers = styled.div`
    flex: 1;
    // height: 40%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
`

const FinalMatch = ({ teams }) => {
    console.log(teams)
    return (
        <Container>
            {/* <Title>Final</Title> */}
            <Body>
                <Team>
                    {teams?.[0]?.player?.avatar ? <Flag src={teams[0].player.avatar} /> : null}
                    <Text>{teams[0].player.name}</Text>
                </Team>
                <Numbers>
                    <Score>
                        <ScoreText>{teams[0].score}</ScoreText>
                        <ScoreText>-</ScoreText>
                        <ScoreText>{teams[1].score}</ScoreText>
                    </Score>
                    <Text>21:03'</Text>
                </Numbers>
                <Team>
                    {teams?.[1]?.player?.avatar ? <Flag src={teams[1].player.avatar} /> : null}
                    <Text>{teams[1].player.name}</Text>
                </Team>
            </Body>
        </Container>
    )
}

export default FinalMatch;